import '../../styles/menu.scss';
function Menu (){

    return (
<ul>
  <li><a href="/" data-title="Студия">Студия</a></li>
  <li><a href="/order" data-title="Заказать">Заказать</a></li>
  <li><a href="/projects" data-title="Портфолио">Портфолио</a></li>
  <li><a href="/contacts" data-title="Контаткты">Контаткты</a></li>
</ul>
    );
}

export default Menu;